import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'; // eslint-disable-line no-unused-vars

class Button extends Component {
  render() {
    return (
      <div className="cta-button">
        <Link className={this.props.type} to={this.props.link}>{this.props.title}</Link>
      </div>
    )
  }
}

//types = primary / secondary / tertiary

export default Button



// WEBPACK FOOTER //
// ./src/shared/button.js